export default __webpack_public_path__ + "static/4-a3e55a028298dcce412731157aff8574.png";